import { z } from "zod";

import { isObject } from "../type-guard";

const DOES_NOT_MATCH_REGEX = "does_not_match_regex";
const CUSTOM_CODE = "customCode";

type RegexIssue = Omit<z.ZodCustomIssue, "params"> & {
  params: {
    [CUSTOM_CODE]: typeof DOES_NOT_MATCH_REGEX;
    regexCode: RegexCode;
  };
};

function isRegexIssue(value: z.ZodIssueOptionalMessage): value is RegexIssue {
  return (
    value.code === z.ZodIssueCode.custom &&
    isObject(value.params) &&
    value.params[CUSTOM_CODE] === DOES_NOT_MATCH_REGEX
  );
}

const zRegexCode = z.enum(["MUST_MATCH_PHONE_NUMBER_FORMAT"]);
const RegexCode = zRegexCode.Values;
type RegexCode = z.infer<typeof zRegexCode>;

type RegexMapEntryValue = {
  regex: RegExp;
  errorMessage: string;
};

const REGEX_MAP: Record<RegexCode, RegexMapEntryValue> = {
  [RegexCode.MUST_MATCH_PHONE_NUMBER_FORMAT]: {
    regex: /^\+(?:[0-9]){6,14}[0-9]$/,
    errorMessage: "Must match the phone number format",
  },
};

function matchesRegex(regexCode: RegexCode) {
  const { regex } = REGEX_MAP[regexCode];
  return (value: string, ctx: z.RefinementCtx) => {
    if (!value.match(regex)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        params: {
          customCode: DOES_NOT_MATCH_REGEX,
          regexCode,
        } satisfies RegexIssue["params"],
      });
    }
  };
}

const REFINEMENTS = {
  mustMatchPhoneNumberFormat: matchesRegex(RegexCode.MUST_MATCH_PHONE_NUMBER_FORMAT),
};

const errorMap: z.ZodErrorMap = (issue, ctx) => {
  if (isRegexIssue(issue)) {
    return {
      message: REGEX_MAP[issue.params.regexCode].errorMessage,
    };
  }

  return {
    message: ctx.defaultError,
  };
};

export { errorMap, isRegexIssue, REFINEMENTS, RegexCode };
export type { RegexIssue };
